var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImpersonationAttempt = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 27",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.433 12.82h2.593V4.56c0-.62-.506-1.126-1.127-1.126h-7.577v.368a.78.78 0 0 1-1.56 0v-.368H5.264c-.621 0-1.126.505-1.126 1.127v8.254h2.516a.78.78 0 0 1 0 1.56H4.138v6.821c0 .622.505 1.127 1.126 1.127h7.47v-1.017a.78.78 0 0 1 1.56 0v1.017h7.605c.621 0 1.127-.505 1.127-1.127v-6.818l-.037.001h-2.556a.78.78 0 0 1 0-1.56m-8.295-1.557a3.275 3.275 0 1 1 3.025.024c1.01.204 1.883.79 2.46 1.599l-1.743.027a1 1 0 0 0-.127.014 2.22 2.22 0 0 0-1.377-1.442l.03-1.929a.78.78 0 0 0-1.56-.024l-.03 1.96v.005a2.24 2.24 0 0 0-1.328 1.37l-.044-.002h-.012l-1.9.03a4 4 0 0 1 2.606-1.632m1.957 2.815a.68.68 0 0 1-1.167-.484c0-.183.07-.355.2-.484a.682.682 0 0 1 .966 0c.268.267.268.7 0 .968m4.27 5.136a.644.644 0 0 1-.645.644H9.442a.644.644 0 0 1-.643-.644v-4.009q0-.512.123-.99c.142.15.342.241.563.241h.012l1.96-.03.068-.005a2.238 2.238 0 0 0 1.364 1.298.8.8 0 0 0-.035.22l-.03 1.96a.78.78 0 0 0 .767.792h.012a.78.78 0 0 0 .78-.768l.03-1.96a.8.8 0 0 0-.04-.258 2.24 2.24 0 0 0 1.315-1.26.8.8 0 0 0 .203.028h.012l1.96-.03a.77.77 0 0 0 .404-.121q.097.427.098.883z"
  })));
};
export default SvgImpersonationAttempt;